export const base_url = `${process.env.REACT_APP_SERVER_URL}/api`;
